import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useItemStock = (orderNo, itemNo, enabled) => {
  return useQuery({
    queryKey: ["itemStockState", orderNo, itemNo],
    enabled: enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes retained in cache
    queryFn: async () =>
      callApi({
        path: "getitemstock",
        command: "",
        data: JSON.stringify({
          data: { filter: { orderId: orderNo, itemNo: itemNo } },
        }),
      }),
  });
};
